const NBSP = " ";
const BYTES_IN_KILOBYTE = 1024;
const BYTES_IN_MEGABYTE = BYTES_IN_KILOBYTE * 1024;

const fileSizeFormatter = new Intl.NumberFormat("cs-CZ", {
	maximumFractionDigits: 1,
});

export const formatFileSize = (bytes: number): string => {
	if (bytes >= BYTES_IN_MEGABYTE) {
		return `${fileSizeFormatter.format(bytes / BYTES_IN_MEGABYTE)}${NBSP}MB`;
	}

	if (bytes >= BYTES_IN_KILOBYTE) {
		return `${fileSizeFormatter.format(bytes / BYTES_IN_KILOBYTE)}${NBSP}kB`;
	}

	return `${bytes}${NBSP}B`;
};
